import backChevron from "./backChevron.svg";
import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Svg from "react-svg-inline";
import { Transition } from "react-transition-group";
import burgerIcon from "./burgerIcon.svg";
import styles from "./index.module.css";
import SaveIcon from "../SaveIcon";
import FilterIcon from "../FilterIcon";

const NavHandle = ({ onNavOpen, isOpen, children, chapters, navSection }) => {
  let sectionTitle;
  let backUrl;
  if (navSection) {
    sectionTitle = navSection.title;
    backUrl = navSection.backUrl;
  }

  return (
    <div className={styles.root}>
      <h1 className={styles[`title${isOpen ? "Open" : ""}`]}>
        {sectionTitle || "Menu"}
      </h1>
      <Transition in={!isOpen} timeout={200}>
        {state => (
          <nav className={styles[`nav${state}`]}>
            <div className={styles.chapters}>
              {chapters.map(chapter => (
                <Link
                  key={chapter.titleNumber}
                  to={chapter.path}
                  className={styles.link}
                  activeClassName={styles.linkActive}
                >
                  {chapter.titleNumber}
                </Link>
              ))}
            </div>
            <div className={styles.savedArticles}>
              <Link
                to="/saved/"
                className={styles.link}
                activeClassName={styles.linkActive}
              >
                <SaveIcon className={styles.linkSvg} component="<div>" />
              </Link>
            </div>
            <div className={styles.filterArticles}>
              <Link
                to="/filter/"
                className={styles.link}
                activeClassName={styles.linkActive}
              >
                <FilterIcon
                  className={styles.linkSvgFilter}
                  fill="currentColor"
                  stroke="currentColor"
                  component="<div>"
                />
              </Link>
            </div>
          </nav>
        )}
      </Transition>
      {backUrl && (
        <Link
          key="backbutton"
          to={backUrl}
          alt={`Back to ${sectionTitle} overview`}
          className={styles.back}
        >
          <Svg
            className={styles.backSvg}
            svg={backChevron}
            cleanup={["fill"]}
            fill="none"
          />
        </Link>
      )}
      <button className={styles.button} onClick={onNavOpen}>
        <span className={styles.buttonInner}>
          <Svg
            className={styles.burgerIcon}
            svg={burgerIcon}
            cleanup={["fill"]}
          />
        </span>
      </button>
      {children}
    </div>
  );
};

NavHandle.propTypes = {
  onNavOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      titleNumber: PropTypes.string,
      path: PropTypes.string
    })
  ),
  title: PropTypes.string,
  navSection: PropTypes.shape({
    backUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  })
};

export default NavHandle;



// WEBPACK FOOTER //
// ./src/components/NavHandle/index.js